import type { CSSProperties } from 'react'

/**
 * Shared base style for every button in the patient header's right-hand action
 * group (`<PatientChartActionBar>`, plus the callers that feed its
 * `extraActions` slot).
 *
 * Why a raw `<button>` instead of Mantine `<Button>`:
 *   Mantine `<Button>` injects its own font stack, flex container, and
 *   internal padding rules. Mixing it with the raw `<button>` used by the
 *   HG sync pill (`renderHgStatus`) produced inconsistent heights and
 *   text alignment — Mantine compounded the `padding` ON TOP OF the
 *   explicit `height: 40` we passed, so the buttons were taller than the
 *   pill. Using one primitive for all elements is the only reliable way
 *   to guarantee identical metrics.
 *
 * Per-button color overrides are spread on top of this base.
 */
export const ACTION_BUTTON_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  height: 36,
  padding: '0 14px',
  borderRadius: 7,
  fontSize: 13,
  fontWeight: 600,
  fontFamily: 'inherit',
  lineHeight: 1,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  border: '1px solid',
  transition: 'all 150ms',
  outline: 'none',
  flexShrink: 0,
}
